module.exports = __webpack_public_path__ + "img/15.3f596ae2.png";